import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { authApi, type AuthStatus } from '@/lib/api';

export const SETUP_STATUS_KEY = ['auth', 'status'] as const;

/**
 * GET /api/auth/status. When the API cannot be reached the login screen is shown: setup is a one-time
 * step and an unreachable API must never lock existing users out.
 */
export function useSetupStatus(enabled = true): UseQueryResult<AuthStatus> {
  return useQuery({
    queryKey: SETUP_STATUS_KEY,
    queryFn: async (): Promise<AuthStatus> => {
      try {
        return await authApi.status();
      } catch {
        return { setupRequired: false };
      }
    },
    enabled,
    staleTime: 0,
    retry: false,
  });
}
